var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-envelope',{directives:[{name:"statusbar",rawName:"v-statusbar.hide",modifiers:{"hide":true}}],style:({
    background: _vm.background
  })},[_c('top-small',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('back-button-government-home',{staticStyle:{"color":"var(--interaction-dark)"}})]},proxy:true},{key:"default",fn:function(){return [_c('navbar',{staticClass:"px-8"})]},proxy:true}])}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }